import { AfterViewInit, ComponentRef, Directive, EventEmitter, Input, OnDestroy, Output } from "@angular/core";
import { AvanoPopoverDirective } from "@avano/avano-components/avano-popover/avano-popover.directive";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { AvanoErrorsDetailsComponent, ErrorDetail } from './errors-details.component';

@Directive({
  selector: '[avanoErrorsPopover]'
})
export class AvanoErrorsPopoverDirective extends AvanoPopoverDirective implements AfterViewInit, OnDestroy {
  private destroyed$ = new Subject();

  private _errorsDetails: ErrorDetail[] = [];
  @Input('avanoErrorsPopover') set errorsDetails(newDetails: ErrorDetail[]) {
    this._errorsDetails = newDetails;
    if (this.errorsDetailsComponentRef) {
      this.errorsDetailsComponentRef.instance.errorDetails = newDetails;
      this.errorsDetailsComponentRef.changeDetectorRef.markForCheck();
    }
  }
  get errorsDetails() {
    return this._errorsDetails;
  }
  errorsDetailsComponentRef: ComponentRef<AvanoErrorsDetailsComponent>;
  @Output() errorSourceLinkClicked: EventEmitter<void> = new EventEmitter();

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    const errorDetailsFactory = this.componentFactoryResolver.resolveComponentFactory(AvanoErrorsDetailsComponent);
    this.popoverComponentInstance.opened.pipe(takeUntil(this.destroyed$)).subscribe((_) => {
      this.popoverComponentInstance.childrenSeparators = false; // errorDetailsComponent brings its' own separators
      this.errorsDetailsComponentRef = this.popoverComponentInstance.vcRef.createComponent(errorDetailsFactory);
      this.errorsDetailsComponentRef.instance.errorDetails = this.errorsDetails;
      this.errorsDetailsComponentRef.instance.errorSourceLinkClicked.pipe(takeUntil(this.destroyed$)).subscribe({
        next: () => {
          this.popoverComponentInstance.hide();
          this.errorSourceLinkClicked.emit()
        }});
      this.popoverComponent.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }
}
